<template>
  <div>
    <v-btn @click="showModal()" :round="round" small ref="test">options</v-btn>

    <v-dialog v-model="enabled" @keydown.esc.prevent="closeOptionsModal()" :fullscreen="$vuetify.breakpoint.xsOnly" @input="v => v || closeOptionsModal()">
      <v-card>
        <v-container fluid pa-0 ma-0 fill-height>
          <v-layout row>
            <v-flex class="hidden-xs-only" sm4 max-width="200px">
              <v-list pa-0 ma-0 >
                <v-list-tile
                  @click="panel = 'details'"
                  :color="panel === 'details' ? 'primary' : ''"
                >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-info-circle</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Details</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  @click="panel = 'associated'"
                  :color="panel === 'associated' ? 'primary' : ''"
                  v-if="scheduleDetails.associatedTransactions && scheduleDetails.associatedTransactions.length && scheduleDetails.associatedTransactions.reduce((a, c) => c.request_type !== 'modify' ? ++a : a, 0)"
                >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-sitemap</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Associated</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  @click="panel = 'receipt'"
                  :color="panel === 'receipt' ? 'primary' : ''"
                  v-if="scheduleDetails.response_code === '000' && (scheduleDetails.request_type !== 'ach' || scheduleDetails.ach_is_authorized)"
                >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-file-text</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Receipt</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  @click="panel = 'recurring'"
                  :color="panel === 'recurring' ? 'primary' : ''"
                  v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions'))"
                  >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-refresh</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Edit Recurring</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  @click="panel = 'modifications'"
                  :color="panel === 'modifications' ? 'primary' : ''"
                  v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions'))"
                  >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-exchange</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Modifications</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                  :to="{ name: (scheduleDetails.request_type === 'ach' || scheduleDetails.request_type === 'achvoid' || scheduleDetails.request_type === 'achcredit' ) ? 'ChargeACH' : 'ChargeCard', query: { transaction: chargeTransactionId }}"
                  @click="panel = 'charge'"
                  :color="panel === 'charge' ? 'primary' : ''"
                  v-if="hasPermission('can_use_virtual_terminal') && scheduleDetails.token_id && chargeTransactionId"
                >
                  <v-list-tile-action style="min-width:36px">
                    <v-icon>fa-credit-card</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Charge Customer</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>

              <v-divider
                inset
                vertical
              ></v-divider>
            </v-flex>

            <v-flex xs12 sm10>
              <v-toolbar dense flat>
                <v-toolbar-title></v-toolbar-title>
                <v-toolbar-items class="hidden-sm-and-up">
                  <v-btn
                    @click="panel = 'details'"
                    :color="panel === 'details' ? 'primary' : ''"
                    icon
                    small
                  >
                    <v-icon>fa-info-circle</v-icon>
                  </v-btn>

                  <v-btn
                    @click="panel = 'associated'"
                    :color="panel === 'associated' ? 'primary' : ''"
                    v-if="scheduleDetails.associatedTransactions && scheduleDetails.associatedTransactions.length && scheduleDetails.associatedTransactions.reduce((a, c) => c.request_type !== 'modify' ? ++a : a, 0)"
                    icon
                    small
                  >
                    <v-icon>fa-sitemap</v-icon>
                  </v-btn>

                  <v-btn
                    @click="panel = 'receipt'"
                    :color="panel === 'receipt' ? 'primary' : ''"
                    v-if="scheduleDetails.response_code === '000' && (scheduleDetails.request_type !== 'ach' || scheduleDetails.ach_is_authorized)"
                    icon
                    small
                  >
                    <v-icon>fa-file-text</v-icon>
                  </v-btn>

                  <v-btn
                    @click="panel = 'recurring'"
                    :color="panel === 'recurring' ? 'primary' : ''"
                    v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions'))"
                    icon
                    small
                  >
                    <v-icon>fa-refresh</v-icon>
                  </v-btn>

                  <v-btn
                    @click="panel = 'modifications'"
                    :color="panel === 'modifications' ? 'primary' : ''"
                    v-if="(hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions'))"
                    icon
                    small
                  >
                    <v-icon>fa-exchange</v-icon>
                  </v-btn>

                  <v-btn
                    :to="{ name: (scheduleDetails.request_type === 'ach' || scheduleDetails.request_type === 'achvoid' || scheduleDetails.request_type === 'achcredit' ) ? 'ChargeACH' : 'ChargeCard', query: { transaction: chargeTransactionId }}"
                    @click="panel = 'charge'"
                    :color="panel === 'charge' ? 'primary' : ''"
                    v-if="hasPermission('can_use_virtual_terminal') && scheduleDetails.token_id && chargeTransactionId"
                    icon
                    small
                  >
                    <v-icon>fa-credit-card</v-icon>
                  </v-btn>
                </v-toolbar-items>

                <v-spacer></v-spacer>
                <h3 class="primary--text text-capitalize">{{ panel }}</h3>
                <v-btn icon flat color="primary" @click.native="closeOptionsModal()">
                  <v-icon>fa-close</v-icon>
                </v-btn>
              </v-toolbar>

              <DetailsPanel :schedule="scheduleDetails" v-if="panel === 'details'"/>

              <AssociatedPanel :transaction="scheduleDetails" v-if="panel === 'associated'"/>

              <ReceiptPanel :transaction="scheduleDetails" v-if="panel === 'receipt'"/>

              <ModifyPanel :schedule="scheduleDetails" :scheduledTransactions="scheduledTransactions" v-if="panel === 'recurring' && (hasPermission('can_manage_transactions') || hasPermission('can_manage_account_transactions'))"/>

              <ModificationsPanel :transaction="scheduleDetails" v-if="panel === 'modifications'"/>


            </v-flex>
          </v-layout>
        </v-container>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Bus from '@/bus'
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'

import AssociatedPanel from '../transactions/Associated.vue'
import DetailsPanel from './Details.vue'
import ModificationsPanel from '../recurring/Modifications.vue'
import ModifyPanel from './Modify.vue'
import ReceiptPanel from '../transactions/Receipt.vue'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, RecurringMixin, StoreMixin],
  components: {AssociatedPanel, DetailsPanel, ModificationsPanel, ModifyPanel, ReceiptPanel},
  data: function () {
    return {
      enabled: false,
      panel: 'details',
      scheduleDetails: {},
      scheduledTransactions: [],
      chargeTransactionId: null
    }
  },

  props: {
    round: Boolean,
    scheduleId: Number
  },

  created () {},

  beforeDestroy () {
    Bus.$off('closeOptionsModal')
    Bus.$off('openTransaction')
    this.panel = ''
    this.scheduleDetails = Object.assign({}, {})
    this.chargeTransactionId = null
  },

  mounted () {
    Bus.$on('closeOptionsModal', this.closeOptionsModal)
    Bus.$on('openTransaction', this.openTransaction)
  },

  methods: {
    async showModal (panel = 'details') {
      try {
        let data = await this.api({url: `/schedules/${this.scheduleId}`})
        this.scheduleDetails = data.data.schedule
        this.enabled = true
        this.panel = panel
        this.scheduledTransactions = this.getScheduledPayments(this.scheduleDetails)

        this.chargeTransactionId = null
        if (this.scheduleDetails.token_id) {
          try {
            let txnData = await this.api({
              url: `/schedules/${this.scheduleId}/transactions`,
              params: { page: 0, perPage: 10 }
            })
            if (txnData.data.rows && txnData.data.rows.length) {
              const successful = txnData.data.rows.filter(t => t.response_code === '000')
              if (successful.length) {
                this.chargeTransactionId = successful[0].id
              }
            }
          } catch (e) {}
        }
      } catch (err) {
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      }
    },

    openTransaction () {
      this.panel = 'details'
      this.enabled = false
    },

    closeOptionsModal () {
      Bus.$emit('optionsClose')
      this.panel = ''
      this.enabled = false
      this.chargeTransactionId = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/schedules/OptionsModal.vue